<!--
  Template for a tag group (eg. Categories, People, etc.)
  Shows a small number of tags, with a '+ xx' button that
  triggers the remaining tags of that type to be shown
-->
<div class="feed-topics">
  <ui2-tag
    *ngFor="let item of showOverflow ? items : (items | slice: 0:initialNumTagsToShow)"
    class="feed-topics-tag"
    [title]="isClickable ? (tooltip || 'newsFeedWidget.feed.promote' | translate: { title: item.label } | titleCase) : item.label"
    [label]="item.label | titleCase: DEFAULT_CASE_LANGUAGE:'skip'"
    [isClickable]="isClickable"
    [size]="'extraSmall'"
    (onClicked)="clicked.emit(item)"
    (click)="preventClickPropagation($event)"
  ></ui2-tag>
  <!-- Show-more trigger -->
  <ui2-tag
    *ngIf="items.length > initialNumTagsToShow && !showOverflow"
    [isClickable]="true"
    [size]="'extraSmall'"
    [label]="'newsFeedWidget.tagCloud.showMoreToggle' | translate: { number: items.length - initialNumTagsToShow }"
    (onClicked)="expandAccordion()"
    (click)="preventClickPropagation($event)"
  ></ui2-tag>
</div>
